import React, { useState, useEffect } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { CardsGrid, Loader } from 'quantux-ui';
import { blue, gray } from '../../theme';
import { BASE_URL } from '../../utils';

const DOCS_PER_PAGE = 50;

const ProviderFacilitiesGrid = (props) => {
  const [gridData, setGridData] = useState([]);
  const [docsCount, setDocsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [gridWidth, setGridWidth] = useState(window.innerWidth <= 768 ? window.innerWidth - 16 : 550);
  const [gridHeight, setGridHeight] = useState(window.innerHeight - 143);
  const [showLoader, setShowLoader] = useState(false);

  // --- Network Ops ----------------------------------------------------
  const getData = () => {
    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);
    // const url = new URL(`${BASE_URL}/users/getFacilities`);
    const url = new URL(`${BASE_URL}/facility/getFacilities`);
    const params = { userId: props.userId };
    url.search = new URLSearchParams(params).toString();

    const requestOptions = {
      method: 'GET',
      headers: reqHeaders,
      redirect: 'follow'
    };

    fetch(url, requestOptions)
      .then(res => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        console.log(data);
        // const tmpData = [];
        // for (let i = 0; i < data.facilities; i++) {
        //   tmpData.push({
        //     id: data.facilities[i]._id,
        //     facilityName: data.facilities[i].facilityName,
        //     npi: data.facilities[i].npi,
        //     userName: data.facilities[i].userName,
        //     displayName: data.facilities[i].displayName
        //   });
        // }
        // setGridData(data.facilities);
        setGridData(data.facilities);
      })
      .catch(error => console.log('error', error));
  };

  // --- Effects --------------------------------------------------------
  useEffect(() => {
    getData();
  }, []);

  // --- Styles ---------------------------------------------------------
  const styles = StyleSheet.create({
    gridContainer: {
      height: '100%',
      overflowY: 'hidden',
      position: 'relative',
      display: 'flex',
      flexFlow: 'column'
    },
    gridToolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '40px',
      marginBottom: '2px',
      paddingLeft: '4px',
      background: gray[500],
      width: '100%'
    },
    gridToolbarIcon: {
      height: '50px',
      width: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      ':hover': {
        color: blue[500]
      }
    },
    facilityCard: {
      width: '320px',
      height: '152px',
      background: blue[700],
      color: blue[200],
      padding: '8px'
    },
    facilityCardHeading: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    facilityCardHeadingText: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: '700'
    },
    facilityCardAvatar: {
      maxHeight: '32px',
      width: 'auto',
      marginRight: '8px'
    },
    facilityCardHeadingSubText: {
      fontSize: '12px',
      fontWeight: '700',
      color: blue[400]
    },
    facilityCardHeadingIcon: {
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '32px',
      height: '32px',
      background: blue[700],
      color: blue[200],
      fontSize: '18px'
    },
    facilityCardDataLine: {
      display: 'flex',
      alignItems: 'center'
    },
    facilityCardDataLineIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: blue[800],
      borderRadius: '2px',
      width: '32px',
      height: '32px',
      fontSize: '22px'
    }
  });

  return (
    <div className={`p-2 ${css(styles.gridContainer)}`}>
      {showLoader &&
        <Loader
          iconType="cog"
          iconSize="5x"
          text='Loading data ...'
          style={{
            position: 'absolute',
            background: 'black',
            opacity: '0.9'
          }}
        />
      }
      {/* Grid Toolbar */}
      <div className={css(styles.gridToolbar)}>
        {/* Left side icons */}
        <div />
        {/* Right side icons */}
        <div className='fx'>
          {/* Reset button */}
          <div className={css(styles.gridToolbarIcon)}>
            <i className="fa fa-lg fa-refresh" />
          </div>
          {/* Vertical ellipsis */}
          <div className={css(styles.gridToolbarIcon)} style={{ fontSize: '16px' }}>
            <span className='fa-stack'>
              <i className='fa fa-circle fa-stack-2x' />
              <i className='fa fa-ellipsis-v fa-stack-1x' style={{ color: gray[700] }} />
            </span>
          </div>
        </div>
      </div>
      {/* --- Cards Grid --- */}
      <CardsGrid
        rowData={gridData}
        gridWidth={gridWidth}
        gridHeight={gridHeight}
        loader={false}
        style={{ flexGrow: '1', overflowY: 'auto' }}
        cardHeight='152px'
        cardWidth='320px'
        totalPages={Math.ceil(docsCount / DOCS_PER_PAGE)}
        currentPage={currentPage}
        onLoadPage={(page) => { setCurrentPage(page); }}
        cardRenderer={(data) => {
          const { mAdd = {} } = data;
          let mailingAddressLine1 = 'Mailing Address not available';
          let mailingAddressLine2 = '';
          if (mAdd && Object.keys(mAdd).length > 0) {
            mailingAddressLine1 = `${mAdd.streetAddress1}${(mAdd.suite && mAdd.suite.length > 0) ? ` ${mAdd.suite}` : ''}`;
            mailingAddressLine2 = `${mAdd.city || ''}${mAdd.state && mAdd.state.length > 0 ? `, ${mAdd.state}` : ''}${mAdd.zip && mAdd.zip.length > 0 ? ` ${mAdd.zip}` : ''}`;
          }
          return (
            <div className={css(styles.facilityCard)}>
              {/* Heading */}
              <div className={css(styles.facilityCardHeading)}>
                <div className={css(styles.facilityCardHeadingText)}>
                  <img
                    className={css(styles.facilityCardAvatar)}
                    src={data.avatarImageUrl}
                  />
                  <div className={css(styles.facilityCardHeadingSubText)}>
                    <div>{data.displayName}</div>
                    <div>
                      {`@${data.userName}`}
                    </div>
                  </div>
                </div>
                {/* Ellipsis Menu */}
                <div className={css(styles.facilityCardHeadingIcon)}>
                  <i className='mr-2 fa fa-trash' />
                  <i className='fa fa-cog' />
                </div>
              </div>
              {/* Facility Address & Pbone */}
              <div className='mt-2'>
                {/* Mailing Address Row */}
                <div className={css(styles.facilityCardDataLine)}>
                  {/* Icon */}
                  <div className={css(styles.facilityCardDataLineIcon)}>
                    <i className='fa fa-home' />
                  </div>
                  {/* Value */}
                  <div className='ml-2'>
                    <div>{mailingAddressLine1}</div>
                    <div>{mailingAddressLine2}</div>
                  </div>
                </div>
                {/* Phone */}
                <div className={`mt-2 ${css(styles.facilityCardDataLine)}`}>
                  {/* Icon */}
                  <div className={css(styles.facilityCardDataLineIcon)}>
                    <i className='fa fa-phone' />
                  </div>
                  {/* Value */}
                  <div className='ml-2'>
                    <div>{data.phoneNumber || 'Not available'}</div>
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      />
    </div>
  );
};

export default ProviderFacilitiesGrid;
